import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

type Tone = 'brand' | 'accent' | 'success' | 'warning' | 'danger' | 'neutral'

const tones: Record<Tone, string> = {
  brand: 'bg-brand-50 text-brand-700 border-brand-100',
  accent: 'bg-accent-50 text-accent-700 border-accent-100',
  success: 'bg-success-bg text-success border-success/20',
  warning: 'bg-warning-bg text-warning border-warning/20',
  danger: 'bg-danger-bg text-danger border-danger/20',
  neutral: 'bg-neutral-100 text-fg-2 border-border',
}

interface BadgeProps {
  tone?: Tone
  children: ReactNode
  className?: string
}

export function Badge({ tone = 'neutral', children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 h-5 rounded-pill text-2xs font-semibold uppercase tracking-wide border',
        tones[tone],
        className,
      )}
    >
      {children}
    </span>
  )
}
